import "./index.scss";
import { LiveInspectorData } from "types/types";
import React, { ReactNode, createElement } from "react";
import cn from "classnames";

type Size = "xxxs" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
type TitleTag = "h1" | "h2" | "h3" | "h4" | "h5" | "p";
type Theme = "white" | "black" | "blue" | "grey";

export type EditorialProps = {
  title?: string;
  image?: ReactNode;
  description?: ReactNode;
  size?: Size;
  titleTag: TitleTag;
  theme?: Theme;
  centered?: boolean;
  liveInspector?: LiveInspectorData;
};

const Editorial = ({
  title,
  image,
  description,
  size,
  theme,
  centered,
  titleTag,
  liveInspector,
}: EditorialProps) => {
  const editorialClass = cn("editorial", {
    [`master-editorial--${size}`]: size,
    [`master-editorial--${theme}`]: theme,
    [`master-editorial--centered`]: centered,
  });

  if (!title && !image && !description) return null;

  return (
    <div className={editorialClass} {...liveInspector?.editorial}>
      {image && <div className="master-editorial__image">{image}</div>}
      {title &&
        titleTag &&
        createElement(
          titleTag,
          { className: "master-editorial__title" },
          title,
        )}
      {description && (
        <div
          className={cn("master-editorial__description", {
            [`master-editorial__description--no-margin`]: !title && !!image,
          })}
        >
          {description}
        </div>
      )}
    </div>
  );
};

export default Editorial;
